/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FindSpotList } from '../models/find-spot-list';
import { legacyGetFindSpotList } from '../fn/legacy/legacy-get-find-spot-list';
import { LegacyGetFindSpotList$Params } from '../fn/legacy/legacy-get-find-spot-list';

@Injectable({ providedIn: 'root' })
export class LegacyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `legacyGetFindSpotList()` */
  static readonly LegacyGetFindSpotListPath = '/legacy/document/{documentId}/search/{searchId}/find-spot/list';

  /**
   * Get find spots for document search.
   *
   * Get find spots for document search
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `legacyGetFindSpotList()` instead.
   *
   * This method doesn't expect any request body.
   */
  legacyGetFindSpotList$Response(params: LegacyGetFindSpotList$Params, context?: HttpContext): Observable<StrictHttpResponse<FindSpotList>> {
    const obs = legacyGetFindSpotList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get find spots for document search.
   *
   * Get find spots for document search
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `legacyGetFindSpotList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  legacyGetFindSpotList(params: LegacyGetFindSpotList$Params, context?: HttpContext): Observable<FindSpotList> {
    const resp = this.legacyGetFindSpotList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FindSpotList>): FindSpotList => r.body)
    );
  }

}
